import { MembershipRole } from '@/types/api/membership';

// prettier-ignore
export function membershipRoleLabel(role: MembershipRole): string {
  switch (role) {
    case MembershipRole.Leader: return 'Ledare';
    case MembershipRole.Member: return 'Deltagare';
    case MembershipRole.Parent: return 'Förälder';
    default:                    return 'Okänd';
  }
}

// prettier-ignore
export function membershipRoleBadge(role: MembershipRole): string {
  switch (role) {
    case MembershipRole.Leader: return 'bg-red-500/20 text-red-700';
    case MembershipRole.Member: return 'bg-blue-500/20 text-blue-700';
    case MembershipRole.Parent: return 'bg-violet-500/20 text-violet-700';
    default:                    return 'bg-gray-500/20 text-gray-700';
  }
}
